"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AttachReact_1 = __importStar(require("./AttachReact"));
var Deserialise_1 = require("./Tokenization/Deserialise");
var HtmlTokenizer_1 = __importDefault(require("@CommonFrontend/ContentTokens/HtmlTokenizer/HtmlTokenizer"));
var ShowImagePicker_1 = __importDefault(require("./ShowImagePicker"));
var CommentTokens_1 = require("./Comments/CommentTokens");
var CommentLoader_1 = require("./Comments/CommentLoader");
var InitialiseEditorModules_1 = __importDefault(require("./InitialiseEditorModules"));
var QwilrEditorTelemetry_1 = __importDefault(require("./QwilrEditorTelemetry"));
var UpgradeTokens_1 = require("@CommonFrontend/ContentTokens/Utils/UpgradeTokens");
var mobx_1 = require("mobx");
var template = require("./QwilrEditor.html");
var QwilrEditor = (function () {
    function QwilrEditor(createUi, di, model, configuration, $timeout, usingFeature, block, commentThreadStore, projectStore, modal) {
        var _this = this;
        di.value("editorTelemetry", di.make(QwilrEditorTelemetry_1.default));
        var _a = (0, InitialiseEditorModules_1.default)(di, usingFeature, block, model, configuration), errorRecorder = _a.errorRecorder, showSpinner = _a.showSpinner, router = _a.router, loader = _a.loader, saver = _a.saver, cursorValidator = _a.cursorValidator, configurationObject = _a.configurationObject;
        this.errorRecorder = errorRecorder;
        this.loader = loader;
        this.saver = saver;
        this.configuration = configurationObject;
        di.convoke(this.configuration.registerBehaviours, null, {
            router: router,
            getConversionElem: function () {
                return _this.conversionElem;
            },
        });
        this.model = model;
        this.ui = createUi(template, {
            needsConversion: function () {
                return _this.model.tokens == undefined;
            },
            isLoading: function () {
                return _this.model.tokens == undefined;
            },
            showLoadingSpinner: function () {
                return showSpinner;
            },
            $onElementRendered: function (elem, label) {
                if (label == "editor") {
                    var nonMobxReactiveTokens = (0, mobx_1.toJS)(_this.model.tokens);
                    var tokens = (0, UpgradeTokens_1.upgradeTokens)(nonMobxReactiveTokens, {
                        usingFeature: usingFeature,
                        logError: function (output) {
                            errorRecorder.recordError(new Error("Error while upgrading tokens in QwilrEditor"), { errorDetail: output }, { tokenUpgradeError: "yes" });
                        },
                    });
                    di.convoke(AttachReact_1.default, null, {
                        elem: elem[0],
                        router: router,
                        saver: saver,
                        loader: loader,
                        errorRecorder: _this.errorRecorder,
                        initialState: (0, Deserialise_1.deserialise)(tokens),
                        showImagePicker: di.invoke(ShowImagePicker_1.default),
                        configuration: _this.configuration,
                        cursorValidator: cursorValidator,
                        usingFeature: usingFeature,
                        conversionElem: _this.conversionElem,
                        projectStore: projectStore,
                        modal: modal,
                    });
                    (0, CommentLoader_1.loadComments)((0, CommentTokens_1.getCommentTokens)(_this.model.tokens), commentThreadStore);
                }
                if (label == "conversion-area") {
                    _this.conversionElem = elem[0];
                    if (_this.ui.needsConversion()) {
                        elem[0].innerHTML = _this.model.content;
                        var convertor = new HtmlTokenizer_1.default();
                        var tokens_1 = convertor.tokenize(elem[0], _this.model.widgets);
                        $timeout(function () {
                            _this.model.tokens = tokens_1;
                        });
                    }
                }
                elem.on("$destroy", function () {
                    (0, AttachReact_1.detachReact)(elem[0]);
                });
            },
        });
        window.editor = this;
    }
    QwilrEditor.prototype.loadContent = function (tokens) {
        this.loader.loadContent(tokens);
    };
    QwilrEditor.prototype.getTokenisedContent = function () {
        return this.model.tokens;
    };
    QwilrEditor.prototype.getTokenisedContentWithSelection = function () {
        if (this.saver.saveSlate) {
            return this.saver.saveSlate();
        }
        else {
            return [];
        }
    };
    return QwilrEditor;
}());
exports.default = QwilrEditor;
